import { useEffect } from 'react';

const useSetUpOtp = (onOtpReceived: (otpValue: string) => void): void => {
  useEffect(() => {
    const ac = new AbortController();
    const setUpOtp = async () => {
      if ('OTPCredential' in window) {
        const input = document.querySelector(
          'input[autocomplete="one-time-code"]'
        );
        if (!input) {
          return;
        }
        const form = input.closest('form');
        if (form) {
          form.addEventListener(
            'submit',
            () => {
              ac.abort();
            },
            { once: true }
          );
        }
        try {
          const otp: { code: string } = (await navigator.credentials.get({
            otp: { transport: ['sms'] },
            signal: ac.signal,
          } as CredentialRequestOptions)) as unknown as { code: string };

          if (otp) {
            onOtpReceived(otp.code);
          }
        } catch {}
      }
    };

    void setUpOtp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useSetUpOtp;
